import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export default function useGetTableColumnStats({
  config = {},
  payload = {},
} = {}) {
  const { addNotification } = useNotificationStore();

  return useQuery(
    ['table-ops-column-stats', payload],
    () => axios.post('/api/v1/agent/operation/stats', payload),
    {
      ...config,
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
}
